import React, { Component } from 'react'
import '../styles/FarmerDataForms.css'
import personalInfo from '../images/personal-info.png'
import finance from '../images/financing.png'
import FarmerRegistration from '../farmers/FarmerRegistration'
import FarmerFinancialTransactions from './FarmerFinancialTransactions'

class FarmerDataForms extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			disabled: (props.farmerId != null)? false: true,
			isViewDetails: props.isViewDetails
		}
		this.onMenuItemClick = this.onMenuItemClick.bind(this)
		this.onSignal = this.onSignal.bind(this)
		this.setContent = this.setContent.bind(this)
	}

	componentDidMount() {
		this.setContent(sessionStorage.getItem("farmer-tabId"))
	}

	onSignal(from, obj) {
		this.props.onSignal(from, obj)
	}

	onMenuItemClick(v) {
		this.setState({activeItem: v})
	}

	setContent(id) {
		let content
		switch(id) {
			case "fdh-financial":
				content = <FarmerFinancialTransactions id={this.props.farmerId} />
				break
			default:
				content = <FarmerRegistration  onSignal={this.onSignal} site={this.props.siteId}
					id={this.props.farmerId} regStatus={this.props.regStatus}
					viewClusterDetails={this.props.viewClusterDetails} view={this.props.view} />
		}
		this.setState({content: content})
	}

	render() {
		const view = <div id="farmer-data-forms">
			<Header onItemClick={(item) => {
				this.setContent(item)
				sessionStorage.setItem("farmer-tabId", item)
			}} disabled={this.state.disabled} />
			<Body content={this.state.content} />
		</div>
		return(view)
	}
}

class Header extends Component
{
	constructor(props) {
		super(props)
		this.state = {disabled: props.disabled}
		this.onItemClick = this.onItemClick.bind(this)
		this.mouseEnter = this.mouseEnter.bind(this)
		this.mouseLeave = this.mouseLeave.bind(this)
	}

	componentDidMount() {
		if(this.state.disabled) {
			return
		}
		const items = document.querySelectorAll('#farmer-data-header > div')
		for(const f of items) {
			f.style.color = "#000000"
		}
		const imgs = document.querySelectorAll('#farmer-data-header > div > img')
		for(const f of imgs) {
			f.style.opacity = "1.0"
		}
		const tabId = sessionStorage.getItem("farmer-tabId")
		switch(tabId) {
			case "fdh-financial":
				var elem = document.getElementById(tabId)
				elem.style.background = "#e2e2e2"
				break
			default:
				elem = document.getElementById("fdh-profile")
				elem.style.background = "#e2e2e2"
		}
	}

	componentDidUpdate(prevProps) {
		if(this.props.disabled != prevProps.disabled) {
			this.setState({disabled: this.props.disabled})
			if(this.props.disabled) {
				return
			}
			const items = document.querySelectorAll('#farmer-data-header > div')
			for(const f of items) {
				f.style.color = "#000000"
			}
			const imgs = document.querySelectorAll('#farmer-data-header > div > img')
			for(const f of imgs) {
				f.style.opacity = "1.0"
			}
		}
	}

	onItemClick(e) {
		if(this.state.disabled) {
			return
		}
		const items = document.querySelectorAll('#farmer-data-header > div')
		for(const f of items) {
			f.style.background = "#ffffff"
		}
		e.target.style.background = "#e2e2e2"
		this.props.onItemClick(e.target.id)
	}

	mouseEnter(e) {
		if(this.state.disabled) {
			return
		}
		if(e.target.style.background === "rgb(226, 226, 226)") {
			return
		}
		e.target.style.background = "#e2e2e280"
	}

	mouseLeave(e) {
		if(this.state.disabled) {
			return
		}
		if(e.target.style.background === "rgb(226, 226, 226)") {
			return
		}
		e.target.style.background = "#ffffff"
	}

	render() {
		const view = <div id="farmer-data-header">
			<div id="fdh-profile" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
				onMouseLeave={this.mouseLeave}><img src={personalInfo} />FARMER PROFILE</div>
			<div id="fdh-financial" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
				onMouseLeave={this.mouseLeave}><img src={finance} />FINANCIAL TRANSACTION</div>
		</div>
		return(view)
	}
}

class Body extends Component
{
	constructor(props) {
		super(props)
		this.onItemClick = this.onItemClick.bind(this)
	}

	onItemClick(e) {
		console.log(e.target.id)
	}

	render() {
		const view = <div id="farmer-data-body">
			<div id="fdb-content">
				{this.props.content}
			</div>
		</div>
		return(view)
	}
}

export default FarmerDataForms
